import { ActiveSharedBetSlip, ChatMessageType } from "@data-types/chat";
import React from "react";
import CustomMessage from "./CustomMessage";
import ChatRepliedMessagePreview from "./ChatRepliedMessagePreview";
import { useTranslation } from "react-i18next";
import { handleRepliedMessageScroll } from "@utils/chat";
import { useRootAppStore } from "@hooks";

export default function ChatRepliedMessage(props: {
	message: Amity.Message &
		Amity.RawMessage & {
			parentId?: string;
			data: {
				text?: string;
				sharedSlip: ActiveSharedBetSlip;
				messageType: ChatMessageType.REPLY;
				replyingCreatorId: string;
				replyingMessage: string;
				betSlipData: ActiveSharedBetSlip;
			};
			metadata: {
				isLink?: boolean;
				isMultiOffer?: boolean;
			};
		};
}) {
	const messageData = props.message;
	const rootStore = useRootAppStore();

	const { t } = useTranslation();

	if (!messageData) {
		return null;
	}

	const creatorId =
		messageData.data?.replyingCreatorId !=
		rootStore.userAuthStore.user?.chatName
			? messageData.data?.replyingCreatorId
			: `${t("CHAT.REPLIED_TO_NAME")}`;

	if (messageData.data.messageType == ChatMessageType.REPLY) {
		if (!messageData.data.sharedSlip && !messageData.data.betSlipData) {
			return (
				<div className="chat__thread">
					<div
						className="chat__original"
						onClick={() => {
							handleRepliedMessageScroll(messageData.parentId);
						}}
					>
						<span className="chat__original__sender">
							{creatorId}
						</span>

						{messageData.data.replyingMessage &&
							messageData.data.replyingMessage != " " && (
								<span className="chat__original__message">
									{messageData.data.replyingMessage}
								</span>
							)}
					</div>

					{messageData?.data.text &&
						messageData?.data.text != " " && (
							<div className="chat__replying">
								{messageData.data.text ||
									messageData.data.replyingMessage}
							</div>
						)}
				</div>
			);
		}

		if (messageData.data.sharedSlip && messageData.data.betSlipData) {
			return (
				<div className="chat__thread">
					<div
						className="chat__original"
						onClick={() => {
							handleRepliedMessageScroll(messageData.parentId);
						}}
					>
						<span className="chat__original__sender">
							{creatorId}:
						</span>

						<span className="chat__original__message">
							{messageData.data.replyingMessage}
						</span>

						<ChatRepliedMessagePreview
							betSlipData={messageData.data?.sharedSlip}
							isMultiOffer={
								messageData.data?.sharedSlip.hasBetBuilder
							}
						/>
					</div>

					<CustomMessage
						customMessageData={messageData}
						isLink={messageData.metadata?.isLink}
						isMultiOffer={
							messageData.data?.betSlipData.hasBetBuilder
						}
					/>
				</div>
			);
		}

		if (!messageData.data?.sharedSlip && messageData.data?.betSlipData) {
			return (
				<div className="chat__thread">
					<div
						className="chat__original"
						onClick={() => {
							handleRepliedMessageScroll(messageData.parentId);
						}}
					>
						<span className="chat__original__sender">
							{creatorId}:
						</span>

						{messageData.data.replyingMessage != " " && (
							<span className="chat__original__message">
								{messageData.data.replyingMessage}
							</span>
						)}
					</div>

					<CustomMessage
						customMessageData={messageData}
						isLink={messageData.metadata?.isLink}
						isMultiOffer={
							messageData.data.betSlipData?.hasBetBuilder
						}
					/>
				</div>
			);
		}

		if (messageData.data.sharedSlip && !messageData.data.betSlipData) {
			return (
				<div className="chat__thread">
					<div
						className="chat__original"
						onClick={() => {
							handleRepliedMessageScroll(messageData.parentId);
						}}
					>
						<span className="chat__original__sender">
							{creatorId}:
						</span>

						{messageData.data.replyingMessage &&
							messageData.data.replyingMessage != " " && (
								<span className="chat__original__message">
									{messageData.data.replyingMessage}
								</span>
							)}

						<ChatRepliedMessagePreview
							betSlipData={messageData.data?.sharedSlip}
							isMultiOffer={
								messageData.data.sharedSlip?.hasBetBuilder
							}
						/>
					</div>

					{messageData.data.text && messageData.data.text != " " && (
						<div className="chat__replying">
							{messageData.data.text}
						</div>
					)}
				</div>
			);
		}
	}

	return <></>;
}
